module.exports = __webpack_public_path__ + "img/ticket_notif.56f53d04.svg";